export const PROSEMIRROR_RENDERED_NORMAL_SEVERITY_THRESHOLD = 2000;
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export const PROSEMIRROR_RENDERED_DEGRADED_SEVERITY_THRESHOLD = 3000;
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export const DEFAULT_SAMPLING_RATE_VALID_TRANSACTIONS = 100;
